<div class="d-flex justify-flex-end">
   <div class="ml-2">
      <div class="dropdown">
         <button class="dropbtn">
            <i class="fa fa-download"></i> {{ 'general.export_data' | translate }}
         </button>
         <div class="dropdown-content">
            <a (click)="exportToExcel()">{{ 'general.export_as_excel' | translate }} (.xlsx)</a>
            <a (click)="exportToPDF()">{{ 'general.export_as_pdf' | translate }}</a>
            <a (click)="exportToCSV()">{{ 'general.export_as_csv' | translate }}</a>
         </div>
      </div>
   </div>

   <div class="ml-2">
      <div class="dropdown">
         <button class="dropbtn" [disabled]="!anySelected" [ngClass]="{ disabled: !anySelected }">
            <i class="fa fa-download"></i> {{ 'general.download_reports' | translate }}
         </button>
         <div class="dropdown-content" *ngIf="anySelected">
            <div *ngFor="let report of reports" class="dropdown-item" (click)="toggleSelection(report)">
               <input type="checkbox" [checked]="report.selected" />
               <label>{{ report.name }}</label>
            </div>
            <button class="download-all-btn" (click)="downloadAll()" [disabled]="!anyReportsSelected()"
               [ngClass]="{ disabled: !anyReportsSelected() }">{{ 'general.download' | translate }}</button>
         </div>
      </div>
   </div>
</div>
<br>
<div class="documents-2 shadow white-bg">
   <div class="filter-bar">
      <div class="filter-controls">
         <h4 class="filter-title"> {{ 'general.submissions' | translate }}</h4>

         <div class="filter-group">
            <label for="submissionTitle">{{ 'placeholders.search_by_title' | translate }}</label>
            <div class="input-with-icon">
               <img src="assets/images/icons/search.png" alt="search" />
               <input id="submissionTitle" type="text" class="filter-input" [(ngModel)]="submissionName"
                  (ngModelChange)="filterWithTimeout()" />
            </div>
         </div>

         <div class="filter-group">
            <label for="studentName">{{ 'placeholders.search_by_student' | translate }}</label>
            <div class="input-with-icon">
               <img src="assets/images/icons/search.png" alt="search" />
               <input id="studentName" type="text" class="filter-input" [(ngModel)]="studentName"
                  (ngModelChange)="filterWithTimeout()" />
            </div>
         </div>


         <div class="filter-group">
            <label for="status">{{ 'app.select_assignment' | translate }}</label>
            <div class="custom-select-wrapper">
               <select id="status" class="filter-select" [(ngModel)]="status" (change)="filterWithTimeout()">
                  <option value="3" selected>{{ 'general.all' | translate }}</option>
                  <option value="0">{{ 'new_entries.queue' | translate }}</option>
                   <option value="-1">{{ 'new_entries.processing' | translate }}</option>
                   <option value="1">{{ 'new_entries.processed' | translate }}</option>
                   <option value="2">{{ 'new_entries.suspended' | translate }}</option>
               </select>
               <img src="assets/images/icons/dropdown-arrow-down.png" alt="arrow" class="custom-arrow" />
            </div>
         </div>

                     <div class="filter-group">
               <label for="dateRange">{{ 'app.filter_by_date' | translate }}</label>
               <div [ngClass]="{'inputBorder': startDate || endDate}" class="date-range-filter"
                  [class.active]="startDate || endDate">
                  <input type="text" readonly [value]="getDateRangeDisplayText()" (click)="toggleDateRangePicker()"
                     class="date-range-input" [placeholder]="getDateRangePlaceholder()" />

                  <!-- Date Range Picker Modal -->
                  <div class="date-range-modal" *ngIf="showDateRangePicker" (click)="$event.stopPropagation()">
                     <div class="date-range-content">
                        <!-- From Section -->
                        <div class="date-section">
                           <h5>From</h5>
                           <div class="date-input-group">
                              <input type="date" [(ngModel)]="startDate" (ngModelChange)="onDateRangeChange()"
                                 class="date-input" />
                              <input type="time" [(ngModel)]="startTime" (ngModelChange)="onDateRangeChange()"
                                 class="time-input" />
                           </div>
                        </div>

                        <!-- To Section -->
                        <div class="date-section">
                           <h5>To</h5>
                           <div class="date-input-group">
                              <input type="date" [(ngModel)]="endDate" (ngModelChange)="onDateRangeChange()"
                                 class="date-input" />
                              <input type="time" [(ngModel)]="endTime" (ngModelChange)="onDateRangeChange()"
                                 class="time-input" />
                           </div>
                        </div>
                     </div>

                     <div class="date-range-footer">
                        <button (click)="clearDateRange()" class="clear-btn">Clear</button>
                        <button (click)="applyDateRange()" class="apply-btn">Apply</button>
                     </div>
                  </div>
               </div>
            </div>

         <button class="reset-btn" (click)="resetFilter()" aria-label="Reset filters">
            <div class="reset-icon-wrapper">
               <img src="assets/images/icons/refresh.png" alt="Reset" />
            </div>
         </button>

      </div>
   </div>

   <div tabindex="0" class="table_container" *ngIf="this.submissionsNumber != 0" #contentToCapture>
      <ng-template tabindex="0" #assignmentLinkTemplate let-row>
         <ng-container tabindex="0" *ngIf="row.assignments.assignmentType === 'code'">
            <a tabindex="0" (click)="row.assignments.isChecked ? openCodeReport(row) : $event.preventDefault()"
               [class.disabled-button]="!row.assignments.isChecked" [attr.aria-disabled]="!row.assignments.isChecked"
               [attr.tabindex]="!row.assignments.isChecked ? -1 : null" class="btn-blue-borderless-md">
               {{ 'new_entries.view_report' | translate }}
               <img src="assets/images/icons/link-new-tab.png" alt="report icon" class="report-icon" />
            </a>
         </ng-container>

         <ng-container *ngIf="row.assignments.assignmentType === 'document'">
            <a *ngIf="row.processed == 1" tabindex="0" (click)="goToLink(row.id)" class="btn-blue-borderless-md">
               {{ 'new_entries.view_report' | translate }}
               <img src="assets/images/icons/link-new-tab.png" alt="report icon" class="report-icon" />
            </a>
            <a *ngIf="row.processed == 0 || row.processed == -1 || row.processed == 2"
               (click)="showWarning('Document is still processing.')" class="btn-blue-borderless-md disabled-button"
               [attr.aria-disabled]="true" tabindex="-1">
               {{ 'new_entries.view_report' | translate }}
               <img src="assets/images/icons/link-new-tab.png" alt="report icon" class="report-icon" />
            </a>
         </ng-container>
      </ng-template>

      <ng-template #assignmentTypeTemplate let-row>
         <h5 style="font-size: 14px;" *ngIf="row.assignments.assignmentType == 'code'">{{'new_entries.code_similarity' |
            translate}}</h5>
         <h5 style="font-size: 14px;" *ngIf="row.assignments.assignmentType == 'document'">{{'new_entries.submission' |
            translate}}</h5>
      </ng-template>


      <app-table tabindex="0" [columns]="columns" [paginatedData]="
    submissions
      | paginate : {
          itemsPerPage: 5,
          currentPage: page,
          totalItems: submissionsNumber
        }
  " [data]="allSubmissions" [customTemplates]="{
    assignmentType: assignmentTypeTemplate,
    assignmentLink: assignmentLinkTemplate
     }" (selectionChange)="onTableSelectionChange($event)" (selectAllChanged)="onSelectAllChanged($event)"
         [hasCheckboxes]="true" [userInterfaceDisplay]="userInterfaceDisplay"
         [originalityRiskFactorHighRisk]="originalityRiskFactorHighRisk"
         [originalityRiskFactorMediumRisk]="originalityRiskFactorMediumRisk" [riskString]="riskString">
      </app-table>
   </div>

   <div class="zeroState" *ngIf="
         this.submissionsNumber == 0 &&
         (submissionName != undefined ||
            assignmentType != '-1' ||
            studentName != undefined)
      ">
      {{ 'app.there_are_no_submissions' | translate }}
   </div>
   <div>
      <pagination-controls *ngIf="this.submissionsNumber != 0" class="num" (pageChange)="changePage($event)"
         responsive="true" previousLabel="" nextLabel="">
      </pagination-controls>
   </div>
   <div class="zero-state" *ngIf="
         this.submissionsNumber == 0 &&
         submissionName == undefined &&
         assignmentType == '-1' &&
         studentName == undefined
      ">
      <!-- <img src="../../assets/images/icona-image.png" alt="" /> -->
      <h5 class="bold" style="z-index: 1;">{{ 'app.your_students_dont_have_any_submissions' | translate }}</h5>
   </div>
</div>